/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmDenikSslSpisovyUzel extends GContentBase<SeznamAdmDenikSslSpisovyUzelObj> {
        private seznamObj: SeznamAdmDenikSslSpisovyUzelObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmDenikSslSpisovyUzelObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmDenikSslSpisovyUzel",
                contentCaption: this.sslden ? "jres:33000614" : "jres:33000911", //RC 33000911 : Podací deníky spisového uzlu
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{sslden} - {ixs_su_txt}"
                },
                gridSettings: {
                    columnOrder: this.getColumnOrder()
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }

        private getColumnOrder(): string {
            let columnOrder = "";
            if (this.sslden)
                columnOrder += "ixs_su_txt,"
            else if (this.ixs_su)
                columnOrder += "sslden,"
            else {
                columnOrder += "sslden,ixs_su_txt"
            }
            columnOrder += "dat_zmena,zmenu_prov_txt";
            return columnOrder;
        }
    }

    export class SeznamAdmDenikSslSpisovyUzelObj extends GAdmSeznamBase {
        sslden: string;
        ixs_su: string;

        private openFromSpisovyUzel() {
            return this.ixs_su ? true : false
        }

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            const cntInitializer = ["Gordic.Adm.WebControls.DetailAdmDenikSslSpisovyUzel", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid),
                openSpisovyUzel: this.openFromSpisovyUzel(),
                openDialog: this.tabOpen
            }]
            const inputParams = {
                ID: "DetailAdmDenikSslSpisovyUzel",
                newRecord: isNew,
                sslden: isNew == true ? (this.sslden ? this.sslden : null) : data.sslden,
                ixs_su: isNew == true ? (this.ixs_su ? this.ixs_su : null) : data.ixs_su,
                subrada: isNew == true ? null : data.subrada
            }
            this.openDialogOrModalWindow(cntInitializer, inputParams);
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null;
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*"])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:29808057").addField("gselectbox", Gordic.Prefabs.Select.sslsden(), {
                name: "sslden",
                model: "model.sslden=value.sslden",
                dropdown: true,
                disabled: (this.sslden) ? true : false
            }).addRow("jres:29930682").addField("gselectbox", Gordic.Prefabs.Select.ginspod(), {
                name: "ixs_su",
                model: "model.ixs_su=value.ixs_su",
                dropdown: true,
                disabled: (this.ixs_su) ? true : false
            })
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.sslden) 
                hardFilter["sslden"] = this.sslden
            if (this.ixs_su)
                hardFilter["ixs_su"] = this.ixs_su
            return hardFilter;
        }

        collectData(data: any) {
            if (this.sslden)
                data["sslden"] = this.sslden
            if (this.ixs_su)
                data["ixs_su"] = this.ixs_su
        }

        applydata(filterData: any, poradi_new?: number) {
            this.cnt.isl.AdmDenikSslSpisovyUzel.list({ filters: filterData }).getView().then((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: `${data.ixs_su}#${data.sslden}#${data.subrada}#`,
                nazev: `${data.ixs_su_txt} - ${data.sslden}`
            }
        }
    }
}